export function typeModel(value?: number): string | undefined {
    if (!value) return '';
    let type = '';
    switch (value) {
        case 1:
            type = 'Duplex';
            break;
        case 2:
            type = 'Triplex';
            break;
        case 3:
            type = 'Flat';
            break;
        default:
            type = '';
            break;
    }
    return type;
}
